<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cb6KLb/tc-custom/9781939424891.jpg?1706994112279" alt="This image is the cover for the book Bonding"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bonding
      </h1>
      <p class="bookDescription body article font2">
        <b><i>“Wear your heart on your sleeve.” </i> That’s the saying. But in <i>BONDING</i>, people wear their anxiety on their chests – in the form of a  parasite that shows everyone just what you’re feeling on the inside … </b> <br/><br/><b>WEAR YOUR LOVE ON YOUR CHEST<br/><br/></b> A man, a woman—and their parasites. Marcus has been alone since the loss of his closest friend and has just recently entered into the dating scene, while Laura has drifted in and out of relationships since high school. They meet, they have a great first date, and Marcus almost dies—because the slug-like parasite that everybody carries in this world nearly rejects him, its host. <i>BONDING</i> is a funny, quirky, and honest look at love, in a world where everyone wears their anxiety, not on their sleeves, but on their chest like big ol' leeches.<br/><br/><br/>Fans of Matthew Erman's work on Vault Comics' <i>WITCHBLOOD</i> and Archaia's <i>JIM HENSON'S THE DARK CRYSTAL: AGE OF RESISTANCE</i> will find lots to love in <i> BONDING</i>.  Fans of Image Comics' <i>ICE CREAM MAN VOL. 1</i>, DC Comics' <i>COLLAPSER</i> and even books like <i> THE HOST</i> by Stephenie Meyer and <i>THE PARASITOLOGY TRILOGY</i> by Mira Grant will enjoy this foray into all the stressors of dating...where a parasite is the least of your worries (unless it kills you, that is.) <br/><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew Erman, Emily Pearson
      </h2>
      
      <p class="authorDescription body article">Matthew Erman is a comics writer from Columbus, Ohio. Alongside Lisa Sterle, he co-created the critically acclaimed comic horror series, Long Lost, which was optioned for Film/TV by Producer Jenny Klein (The Witcher, Daisy Jones and The Six). Erman has since worked on the comic book series Jim Henson’s The Dark Crystal: Age of Resistance and graphic novel Power Rangers: Sins of the Future with BOOM! Studios, series Care Bears: Unlock the Magic with IDW, the upcoming  science fiction/ horror / humorous romance original graphic novel BONDING, with artist and co-creator Emily Pearson for Vault Comics, and the smash supernatural action adventure comics series (with artist/co-creator Lisa Sterle) from Vault Comics, WITCHBLOOD. His short work can be found in anthologies such as Corpus (2018), Dead Beats (2019) and Everything is Going Wrong (2019).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Vault Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a257ceec